import React, { useState } from 'react';
import { Importer, ImporterField } from 'react-csv-importer';
import { submitDataCommissionXilnex } from '../../../../API';

export interface XilnexCommissionRow {
  // type: string;
  customer_id: string;
  customer_email: string;
  order_id: string;
  order_datetime: string;
  order_items_sale: string;
  order_total_sale: string;
  // order_currency: string;
  order_item_id: string;
  order_item_variant_id: string;
  order_item_sku: string;
  order_item_title: string;
  order_item_sale: string;
  // cancelled_at: string;
  inserted_at: string;
  // customer_role: string;
  order_name: string;
  paid_at: string;
  quantity: number;
}

const CSVImporterXilnexCommission
 = () => {

  const [rows, setRows] = useState<XilnexCommissionRow[]>([]);

  const handleDataRows = (r: any[]) => {
    const sanitised: XilnexCommissionRow[] = r
      .map((e) => ({
        // type: e.type,
        customer_id: e.customer_id,
        customer_email: e.customer_email,
        order_id: e.order_id,
        order_datetime: e.order_datetime,
        order_items_sale: e.order_items_sale,
        order_total_sale: e.order_total_sale,
        // order_currency: e.order_currency,
        order_item_id: e.order_item_id,
        order_item_variant_id: e.order_item_variant_id,
        order_item_sku: e.order_item_sku,
        order_item_title: e.order_item_title,
        order_item_sale: e.order_item_sale,
        // cancelled_at: e.cancelled_at,
        inserted_at: e.inserted_at,
        // customer_role: e.customer_role,
        order_name: e.order_name,
        paid_at: e.paid_at,
        quantity: e.quantity,
      }))
    setRows((rows) => rows.concat(sanitised));
  };

  const handleComplete = async () => {
    // run importer
    const date = Date.now;
    // const year = today.getFullYear();
    // const month = (today.getMonth() + 1).toString().padStart(2, '0');
    // const date = year + month;

    console.log("rows",rows)
    await submitDataCommissionXilnex(rows, date);
  };

  return (
    <div>
      <h1 style={{ textAlign: 'center' }}>Xilnex Commission</h1>
      <Importer
        dataHandler={(rows, { startIndex }) => {
          handleDataRows(rows);
        }}
        defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
        restartable // optional, lets user choose to upload another file when import is complete
        onComplete={handleComplete}
        /*onStart={({ file, preview, fields, columnFields }) => {
          // optional, invoked when user has mapped columns and started import
          prepMyAppForIncomingData();
        }}

        onClose={({ file, preview, fields, columnFields }) => {
          // optional, if this is specified the user will see a "Finish" button after import is done,
          // which will call this when clicked
          goToMyAppNextPage();
        }}*/

        // CSV options passed directly to PapaParse if specified:
        // delimiter={...}
        // newline={...}
        // quoteChar={...}
        // escapeChar={...}
        // comments={...}
        // skipEmptyLines={...}
        // delimitersToGuess={...}
        // chunkSize={...} // defaults to 10000
        // encoding={...} // defaults to utf-8, see FileReader API
      >
        {/* <ImporterField name="type" label="Type" /> */}
        <ImporterField name="customer_id" label="Customer ID" />
        <ImporterField name="customer_email" label="Customer Email" />
        <ImporterField name="order_id" label="Order ID" />
        <ImporterField name="order_datetime" label="Order Date Time" />
        <ImporterField name="order_items_sale" label="Order Items Sale" />
        <ImporterField name="order_total_sale" label="Order Total Sale" />
        {/* <ImporterField name="order_currency" label="Order Currency" /> */}
        <ImporterField name="order_item_id" label="Order Item ID" />
        <ImporterField name="order_item_variant_id" label="Order Item Variant ID" />
        <ImporterField name="order_item_sku" label="Order Item SKU" />
        <ImporterField name="order_item_title" label="Order Item Title" />
        <ImporterField name="order_item_sale" label="Order Item Sale" />
        {/* <ImporterField name="cancelled_at" label="Cancelled at" /> */}
        <ImporterField name="fulfilled_at" label="Fulfilled at" />
        <ImporterField name="inserted_at" label="Inserted at" />
        {/* <ImporterField name="customer_role" label="Customer Role" /> */}
        <ImporterField name="order_name" label="Order Name" />
        <ImporterField name="paid_at" label="Paid at" />
        <ImporterField name="quantity" label="Quantity" />
      </Importer>
    </div>
  );
};

export default CSVImporterXilnexCommission
;
